import { Injectable, Optional } from '@angular/core';
import { Observable, empty, of, EMPTY } from 'rxjs';
import { tap, switchMap, concatMap } from 'rxjs/operators';
import { BindingList, Repository, ViewModel } from '@farris/devkit';
import { FormLoadingService } from '../form-loading/form-loading.service';
import { FormNotifyService } from '../form-notify.service';
import { LanguageService } from '../languag.service';
import { FormMessageService } from '../form-message.service';
import { FormErrorService } from '../error/form-error.service';

/**
 * å­åè¡¨åæ°æå¡
 */
@Injectable()
class SubListDataService {
  /**
   * æé å½æ°
   */
  constructor(
    private msgService: FormMessageService,
    private repository: Repository<any>,
    private loadingService: FormLoadingService,
    private viewModel: ViewModel,
    @Optional() private languageService: LanguageService,
    private formNotifyService: FormNotifyService,
    private formErrorService: FormErrorService
  ) {
    if (!languageService) {
      this.languageService = LanguageService.getInstance();
    }
    this.viewModel = viewModel;
  }

  /**
   * æ°å¢
   */
  add(): Observable<any> {
    if (this.messagePipe) {
      this.messagePipe.next({ messageType: 'add' });
    }
    const path = this.getPath();
    const loadingTimerId = this.loadingService.showLoadingWithDelay(500);
    const append$ = this.repository.appendByPath(path);

    return append$.pipe(
      tap(() => {
        this.loadingService.hideDelayLoading(loadingTimerId);
      },
      (error) => {
        this.loadingService.hideDelayLoading(loadingTimerId);
        this.formErrorService.exception(this.languageService.addFailed, error);
      })
    );
  }
  /**
   * å¨æå®ä½ç½®æå¥
   * @param position ä½ç½®
   */
  public insert(position: 1 | -1 = -1) {
    if (this.messagePipe) {
      this.messagePipe.next({ messageType: 'insert' });
    }
    const path = this.getPath();
    const loadingTimerId = this.loadingService.showLoadingWithDelay(500);
    const append$ = this.repository.insertByPath(path, position);
    return append$.pipe(
      tap(() => {
        this.loadingService.hideDelayLoading(loadingTimerId);
      },
        error => {
          this.loadingService.hideDelayLoading(loadingTimerId);
          this.formErrorService.exception(this.languageService.addFailed, error);
        }
      )
    );
  }
  /**
   * å é¤å­è¡¨æ°æ®
   */
  remove(id: string, successMsg?: string): Observable<any> {
    const msg = successMsg ? successMsg : '';
    return this.innerRemove(id, false, msg);
  }

  /**
   * å é¤å­è¡¨æ°æ®ï¼ä¸ç¡®è®¤ï¼
   */
  removeWithoutConfirm(id: string): Observable<any> {
    return this.innerRemove(id, true, '');
  }

  /**
   * æ¹éå é¤å­è¡¨
   * @param ids ids
   * @param successMsg èªå®ä¹æç¤ºä¿¡æ¯
   */
  removeChildrenByIds(ids: string, successMsg?: string): Observable<any> {
    if (!ids) {
      this.formNotifyService.warning(this.languageService['plsSelectDeleteData'], { hideTitle: true });
      return EMPTY;
    }
    const action$ = this.msgService.confirm(this.languageService.confirmDeletion);
    return action$.pipe(
      concatMap(result => {
        if (!result) {
          return EMPTY;
        }
        const path = this.getPath();
        const loadingTimerId = this.loadingService.showLoadingWithDelay(500);
        const remove$ = this.repository.batchRemoveByPath(path, ids);
        return remove$.pipe(
          tap(() => {
            this.loadingService.hideDelayLoading(loadingTimerId);
            if (successMsg && successMsg.trim()) {
              let showMessage: boolean = true;
              if (successMsg.startsWith('{') && successMsg.endsWith('}')) {
                try {
                  const options = JSON.parse(successMsg);
                  if (options.showMessage === false) {
                    showMessage = false;
                  }
                } catch { }
              }
              if (showMessage !== false) {
                this.formNotifyService.success(successMsg, { hideTitle: true });
              }
            } else {
              this.formNotifyService.success(this.languageService.deleteSuccess, { hideTitle: true });
            }
            // this.formNotifyService.success(this.languageService.deleteSuccess, { hideTitle: true });
          },
            error => {
              this.loadingService.hideDelayLoading(loadingTimerId);
              this.formErrorService.exception(this.languageService.deleteFailed, error);
            }
          )
        );
      })
    );
  }

  /**
   * å é¤
   */
  innerRemove(id: string, isConfirm: boolean, successMsg: string): Observable<any> {
    if (this.messagePipe) {
      this.messagePipe.next({ messageType: 'remove' });
    }
    if (!id) {
      this.formNotifyService.warning(this.languageService['plsSelectDeleteData'], { hideTitle: true });
      return empty();
    }

    let action$: Observable<boolean>;
    if (isConfirm === false) {
      action$ = this.msgService.question(this.languageService.confirmDeletion);
    } else {
      action$ = of(true);
    }

    return action$.pipe(
      concatMap(result => {
        if (!result) {
          return empty();
        }
        const path = this.getPath();
        const loadingTimerId = this.loadingService.showLoadingWithDelay(500);
        const remove$ = this.repository.removeByPath(path, id);
        return remove$.pipe(
          tap(() => {
            this.loadingService.hideDelayLoading(loadingTimerId);
            if (successMsg && successMsg.trim()) {
              let showMessage: boolean = true;
              if (successMsg.startsWith('{') && successMsg.endsWith('}')) {
                try {
                  const options = JSON.parse(successMsg);
                  if (options.showMessage === false) {
                    showMessage = false;
                  }
                } catch { }
              }
              if (showMessage !== false) {
                this.formNotifyService.success(successMsg, { hideTitle: true });
              }
            } else {
              this.formNotifyService.success(this.languageService.deleteSuccess, { hideTitle: true });
            }
            // this.formNotifyService.success(this.languageService.deleteSuccess, { hideTitle: true });
          },
            error => {
              this.loadingService.hideDelayLoading(loadingTimerId);
              this.formErrorService.exception(this.languageService.deleteFailed, error);
            }
          )
        );
      })
    );
  }

  /**
   * å é¤å¹¶ä¿å­
   * @param id id
   * @param successMsg èªå®ä¹æç¤ºä¿¡æ¯
   */
  removeAndSave(id: string, successMsg?: string): Observable<any> {
    if (this.messagePipe) {
      this.messagePipe.next({ messageType: 'removeAndSave' });
    }
    if (!id) {
      this.formNotifyService.warning(this.languageService.plsSelectDeleteData, { hideTitle: true });
      return empty();
    }
    const action$ = this.msgService.confirm(this.languageService.confirmDeletion);
    return action$.pipe(
      concatMap(result => {
        if (!result) {
          return empty();
        }

        // å é¤å­è¡¨æ°æ®
        const path = this.getPath();
        const loadingTimerId = this.loadingService.showLoadingWithDelay(500);
        const remove$ = this.repository.removeByPath(path, id);

        return remove$.pipe(

          // æ§è¡ä¸»è¡¨ä¿å­
          switchMap(() => {
            const fid = this.viewModel.bindingData.list.currentId as string;
            return this.repository.applyChangesById(fid);
          }),

          // éèå è½½ä¸­
          tap(() => {
            this.loadingService.hideDelayLoading(loadingTimerId);
            if (successMsg && successMsg.trim()) {
              let showMessage: boolean = true;
              if (successMsg.startsWith('{') && successMsg.endsWith('}')) {
                try {
                  const options = JSON.parse(successMsg);
                  if (options.showMessage === false) {
                    showMessage = false;
                  }
                } catch { }
              }
              if (showMessage !== false) {
                this.formNotifyService.success(successMsg, { hideTitle: true });
              }
            } else {
              this.formNotifyService.success(this.languageService.deleteSuccess, { hideTitle: true });
            }
            // this.formNotifyService.success(this.languageService.deleteSuccess, { hideTitle: true });
          },
            error => {
              this.loadingService.hideDelayLoading(loadingTimerId);
              this.formErrorService.exception(this.languageService.deleteFailed, error);
            })
        );
      })
    );
  }
  /**
   * ä¸ç§»æä¸ç§»æ°æ®
   * @param direction æ¹åï¼up | down
   * @param field æåºå­æ®µ
   * @param targets è¦ç§»å¨çæ°æ®
   * @description
   * ä½¿ç¨è¯¥æ¹æ³æ¶æåºå­æ®µå¿é¡»æå¼ï¼å¦åæ æ³æåº
   */
  public move(direction: string | 'up' | 'down', field: string, targets: Array<any> | string) {
    if (!targets) {
      return;
    }
    if (typeof targets === 'string') {
      targets = targets.split(',').filter(p => p);
    }
    const bindingPath = this.viewModel && this.viewModel.bindingPath || null;
    if (!bindingPath) {
      return;
    }
    const bindingList = this.viewModel.bindingData.getList() as BindingList;
    if (!bindingList || bindingList.length < 1) {
      return;
    }
    const base = direction === 'up' ? -1 : 1;
    // ç§»å¨ä¹ååå°å¾ç§»å¨æ°æ®çä¸»é®æç§ç´¢å¼è¿è¡æåº
    if (targets.length > 0) {
      targets = targets.sort((id1: string, id2: string) => {
        const index1 = bindingList.getIndexById(id1);
        const index2 = bindingList.getIndexById(id2);
        return (index2 - index1) * base;
      });
    }
    targets.forEach((target) => {
      const index = bindingList.getIndexById(target);
      if (index === -1) {
        return;
      }
      const item = bindingList.findById(target);
      const position = item.getValue(field);
      // å¾äº¤æ¢çè¡ä¿¡æ¯
      const exchangeRowIndex = index + base;
      if (exchangeRowIndex < 0 || exchangeRowIndex > bindingList.length - 1) {
        // ç¬¬ä¸è¡æ æ³ä¸ç§»ï¼æåä¸è¡æ æ³ä¸ç§»
        return;
      }
      const exchangeRowId = bindingList.getIdByIndex(exchangeRowIndex);
      const exchangeRow = bindingList.findById(exchangeRowId);
      const exchangeRowPosition = exchangeRow[field];
      // ç§»å¨è¡åäº¤æ¢è¡é½æ²¡ææåº
      if (this.isNullOrEmpty(position) && this.isNullOrEmpty(exchangeRowPosition)) {
        return;
      }
      bindingList.swapById(target, exchangeRowId);
      exchangeRow.setValue(field, position, true, true);
      item.setValue(field, exchangeRowPosition, true, true);
    });
  }
  private isNullOrEmpty(value: any) {
    return value === '' || value === null || value === undefined;
  }
  /**
   * è·åå®æ´è·¯å¾
   * @todoï¼å¼ºè¯å«å°ä»è¡¨è¿ä¸çº§
   * fixed by justin: æ ¹æ®bindingPathï¼å¦ææ¯ä»ä»è¡¨ï¼éè¦è·åä¸»è¡¨æ°æ®idåä»è¡¨æ°æ®id
   */
  private getPath(): string {
    const bindingPath = this.viewModel.bindingPath;
    const rid = this.viewModel.bindingData.list.currentId; // rootè¡¨æ°æ®id
    let path = '/' + rid;

    const subPaths = bindingPath.split('/');
    if (subPaths.length > 0) {
      // eg:bindingPathå½¢å¦/edus/grades,splitåæ¯['', 'edus', 'grades']
      // å æ­¤indexä»1å¼å§
      for (let index = 1; index < subPaths.length - 1; index++) {
        const subPath = subPaths[index];
        const subData = this.viewModel.bindingData[subPath];
        if (!subData || !subData.currentId) {
          this.formNotifyService.warning(this.languageService['plsSelectDetailFormData'], { hideTitle: true });
          throw Error(`è·åå­è¡¨å®æ´è·¯å¾åºéï¼æ¾ä¸å°${subData}å¯¹åºçå­è¡¨ï¼æå¯¹åºå­è¡¨æ²¡æå½åè¡ã`);
        }
        path += `/${subPath}/${subData.currentId}`;
      }
    }
    path += '/' + subPaths[subPaths.length - 1];

    return path;
  }
  /**
   * è·åæ ¹ç»ä»¶appContext
   */
  private get messagePipe() {
    if (this.viewModel && this.viewModel.frameContext) {
      const appContext = this.viewModel.frameContext.getFormAppContext() || null;
      if (appContext) {
        return appContext.messagePipe || null;
      }
    }
    return null;
  }
}
export { SubListDataService };
